<section class="z-[9999] fixed flex items-center justify-center inset-0 size-full p-4" [ngClass]="{ 'bg-black/60': hasBackdrop() }">
    <article
        @slideX
        [class]="width()"
        class="absolute top-0 right-0 flex flex-col h-full p-4 md:p-6 overflow-y-auto bg-white rounded-l-lg select-none"
    >
        <div class="mb-4">
            <button (click)="dismiss()">
                <app-icon size="lg" class="text-gray-700" name="material-symbols:keyboard-double-arrow-right"></app-icon>
            </button>
        </div>
        <ng-template dialog></ng-template>
    </article>
</section>
